import React from 'react'
import './ContactBoby.css'
import { Button, TextField, Typography } from '@mui/material'




export default function ContactBody() {
    return (
        <div className='body'>
            <Typography  gutterBottom variant="h5" component="div">
                Contact Me
            </Typography>
            <TextField id="outlined-basic" label="Email" variant="outlined" />
            <TextField id="outlined-basic" label="Name" variant="outlined" />
            <TextField id="outlined-basic" label="Message" variant="outlined" />
            <Button variant="text">Send Message</Button>
        </div>
    )
}
